<mat-card [class.configured]="configureSelected">
    <mat-card-header #header class="widget-header large">
        <mat-card-title>
            <span>{{ aggregationLevel() | aggregationLevel }} Outage Map</span>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="sit-rep-map">
            <eaglei-leaflet-map (mapRef)="mapRef = $event" [mapOptions]="mapOptions"></eaglei-leaflet-map>
        </div>
        <div class="legend">
            <eaglei-nom-legend class="map-legend" (toggleOverrideVisibility)="this.nomSource.redraw()"></eaglei-nom-legend>
        </div>
    </mat-card-content>

    <div class="auto-mask hide-mask" *ngIf="showMask">
        <span class="mask-message">No Data Matches Filters</span>
    </div>
</mat-card>

<mat-menu #download="matMenu">
    <button mat-menu-item (click)="exportComponent()">
        <fa-icon icon="images"></fa-icon>
        Image (PNG)
    </button>
</mat-menu>
